import { omit } from 'lodash';
import { SET_POST_EDITOR_POST } from './actions/post-editor';
import { uouPageOpenedEvent } from './bi-events/uou-events/uou-page-opened-event';
import { uouPublishPostSuccessEvent } from './bi-events/uou-events/uou-publish-post-success-event';
import { uouCreateCommentSuccessEvent } from './bi-events/uou-events/uou-create-comment-success-event';
import { uouUpdateCommentSuccessEvent } from './bi-events/uou-events/uou-update-comment-success-event';
import { uouSavePostDraftSuccessEvent } from './bi-events/uou-events/uou-save-post-draft-success-event';
import { uouDeletePostSuccessEvent } from './bi-events/uou-events/uou-delete-post-success-event';
import { uouSetPostEditorPostEvent } from './bi-events/uou-events/uou-set-post-editor-post-event';
import { uouButtonClickedEvent } from './bi-events/uou-events/uou-button-clicked-event';
import { uouIncrementPostLikeCountEvent } from './bi-events/uou-events/uou-increment-post-like-count-event';
import { uouShowModalEvent } from './bi-events/uou-events/uou-show-modal-event';
import { uouHideModalEvent } from './bi-events/uou-events/uou-hide-modal-event';
import { uouPerformanceEvent } from './bi-events/uou-events/uou-performance-event';

export const eventMap = {
  ...uouPageOpenedEvent,
  ...uouPublishPostSuccessEvent,
  ...uouCreateCommentSuccessEvent,
  ...uouUpdateCommentSuccessEvent,
  ...uouSavePostDraftSuccessEvent,
  ...uouDeletePostSuccessEvent,
  ...uouSetPostEditorPostEvent,
  ...uouButtonClickedEvent,
  ...uouIncrementPostLikeCountEvent,
  ...uouShowModalEvent,
  ...uouHideModalEvent,
  ...uouPerformanceEvent,
};

export const oneAppEventMap = omit(eventMap, [SET_POST_EDITOR_POST]);
